import Brand from '../models/Brand';
import { parseEntities, parseEntity } from './commonConverters';

const SCHEMA = {
  id: (data: any) => data.id ?? data.brandId,
  description: 'description',
  logo: 'logo',
  vehicleType: 'objectType',
  outletId: 'outletId',
};

export function parseBrand(data: any): Brand | null {
  return parseEntity(data, SCHEMA, Brand);
}

export function parseBrands(data: any): Array<Brand> {
  return parseEntities(data, SCHEMA, Brand);
}